var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"600px"}},[_c('video',{staticStyle:{"width":"100%","height":"600px"},attrs:{"id":"myVideo","controls":""}},[_c('source',{staticStyle:{"width":"100%","height":"600px"},attrs:{"src":_vm.video,"type":"video/mp4"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-532d95f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/comm/video.vue
// module id = null
// module chunks = 